import theme from "@theme/";

const ProgressBar = ({ progress }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "8px",
          backgroundColor: "#e5e7eb",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            backgroundColor: `${theme.colors.themeColor}`,
            transition: "transform 0.3s ease-in-out",
          }}
        />
      </div>
      <small style={{ color: "#6b7280" }}>{progress}%</small>
    </div>
  );
};

export default ProgressBar;
